var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "annotations-tab" },
    [
      _c("h3", { staticClass: "mt-0" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Commentaires")))
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.useCategories && _vm.categories.length > 0
          ? _c(
              "div",
              {
                staticClass: "acenter",
                attrs: { id: "annotations-categories" }
              },
              [
                _c(
                  "ul",
                  _vm._l(_vm.categories, function(category, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        class: [
                          _vm.params.relatedtype == category.syscode
                            ? "selected-category"
                            : ""
                        ],
                        on: {
                          click: function($event) {
                            return _vm.getAnnotationByType(category.syscode)
                          }
                        }
                      },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: category.label,
                              placement: "bottom",
                              effect: "light"
                            }
                          },
                          [_c("i", { class: "fa " + category.fa + " fa-15" })]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _vm.enableAnnotForm
            ? _c(
                "div",
                [
                  _c("annotation-form", {
                    attrs: {
                      linkedid: parseInt(_vm.linkedid),
                      linkedtype: _vm.relatedtype,
                      data: _vm.ttData,
                      corptype: _vm.corptype
                    },
                    on: { reloadAnnotations: _vm.getAnnotations }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loadingList
            ? _c(
                "div",
                { staticClass: "prelative annotations-tab__list" },
                [
                  _vm.list.length > 0
                    ? _c("annotations-list", {
                        attrs: {
                          list: _vm.list,
                          data: _vm.ttData,
                          corptype: _vm.corptype
                        },
                        on: { delete: _vm.openModalDelete }
                      })
                    : _c(
                        "div",
                        {
                          staticClass:
                            "placeholder annotations-tab__no-comments"
                        },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$l10n.__("Pas de commentaires.")))
                          ])
                        ]
                      )
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "prelative mh-6" },
                [_c("preloader", { attrs: { display: _vm.loadingList } })],
                1
              )
        ])
      ]),
      _vm._v(" "),
      _c("CompassDialog", {
        attrs: {
          visible: _vm.deleteModal,
          size: "small",
          title: _vm.$t.__("common.actions.delete_message")
        },
        on: {
          "update:visible": function($event) {
            _vm.deleteModal = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "dialog__default" }, [
                  _c(
                    "p",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Confirmez-vous vouloir faire disparaître votre commentaire ?"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _c("li", [
                        _vm._v(
                          "\n                        -\n                        " +
                            _vm._s(
                              _vm.$l10n.__(
                                "Il n’apparaitra plus pour aucun de vos collaborateurs."
                              )
                            ) +
                            "\n                    "
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "- " +
                            _vm._s(
                              _vm.$l10n.__("Ceci est une action définitive.")
                            )
                        )
                      ])
                    ]
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.deleteModal = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__("common.actions.delete"),
                        type: "primary-destructive"
                      },
                      on: {
                        click: function($event) {
                          return _vm.deleteAnnotation()
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }